import React from 'react';
import { AppSkinProps } from '../../../types/decisions';
import CriteriaSetting from './CriteriaSetting';
import './CriteriaSettings.scss';

interface CriteriaSettingsProps {
    criteriaFields: AppSkinProps['criteriaData']['fields'];
    fieldInitialValues: AppSkinProps['fieldInitialValues'];
    onTradeoffValueChange: AppSkinProps['onTradeoffValueChange'];
    onSliderChange: AppSkinProps['onSliderChange'];
    handleClose?: () => void;
    openCriteriaSettings?: (id: string) => void;
    disabled?: boolean;
}

const CriteriaSettings = ({
    criteriaFields,
    fieldInitialValues,
    onTradeoffValueChange,
    onSliderChange,
    handleClose,
    openCriteriaSettings,
    disabled = false,
}: CriteriaSettingsProps) => {
    return (
        <div className="criteria-settings-container">
            {criteriaFields.map((field) => {
                if (field.hide_field) {
                    return null;
                }

                return (
                    <CriteriaSetting
                        key={field.id}
                        field={field}
                        fieldInitialValues={fieldInitialValues}
                        onTradeoffValueChange={onTradeoffValueChange}
                        onSliderChange={onSliderChange}
                        handleModalClose={handleClose}
                        openCriteriaSettings={openCriteriaSettings}
                        disabled={disabled}
                    />
                );
            })}
        </div>
    );
};

export default CriteriaSettings;